/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Edition {
  articleId?: number;
  avgCostTotal?: number;
  avgDaleTotal?: number;
  avgINvoiceTotal?: number;
  avgProductCount?: number;
  compositionCount?: number;
  coverImageUrl?: string;
  dateCreated?: Date;
  description?: string;
  editionId?: number;
  glamclubTradeCount?: string;
  hashtag?: string;
  imageURL?: string;
  isSuperbox?: number;
  lastBoxCount?: number;
  princessLetter?: string;
  productId?: number;
  publicRelease?: Date;
  removedSubscriberCount?: number;
  status?: number;
  subscriberCompositionCount?: number;
  subscriberCount?: string;
  subscriberLimit?: number;
  subscriptionId?: number;
  theme?: string;
  title?: string;
  videoURL?: string;
}
